import { Box, Paper } from "@mui/material";
import LoginForm from "../Components/LoginForm";
import CreateUser from "../Components/CreateUser";
import { useContext } from "react";
import { ConfigLinksDetailsContext } from "../Context/cofingLinksDetailsContext";
import SEO from "../Components/SEO";
import { useTranslation } from "react-i18next";

const Login = () => {
  const { configLinks } = useContext(ConfigLinksDetailsContext);
  const { t } = useTranslation();
  const showRegForm = (configLinks?.showCitizenRegistration ?? true) || (configLinks?.showCompanyRegistration ?? true);
  return (
    <>
      <SEO title={t('login') || "تسجيل الدخول"} />
      <Paper
        elevation={5}
        sx={{
        borderRadius: "27px !important",
        margin: "0 auto",
        overflow: "hidden",
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        backgroundColor: "#FFFFFF",
      }}
    >
      <Box
        sx={{
          flex: showRegForm ? { xs: "1 1 100%", md: "1 1 50%" } : "1 1 100%",
          maxWidth: showRegForm ? { md: "50%" } : "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "stretch",
          backgroundColor: "#FFFFFF",
          // Remove inner border radius; let Paper's radius handle corners to avoid double arc
          borderRadius: 0,
          px: { xs: 2, md: 4 },
          py: { xs: 3, md: 4 },
        }}
      >
        <LoginForm />
      </Box>
      {showRegForm && (
        <Box
          sx={{
            flex: { xs: "1 1 100%", md: "1 1 50%" },
            backgroundColor: "#F4F8FC", // fill right half with blue inside rounded outer
            display: "flex",
            justifyContent: "center",
            alignItems: "stretch",
            borderTopRightRadius: 27,
            borderBottomRightRadius: 27,
            px: { xs: 2, md: 4 },
            py: { xs: 4, md: 4 },
          }}
        >
          <CreateUser />
        </Box>
      )}
    </Paper>
    </>
  );
};
export default Login;
